export default "__VITE_ASSET__DTbkQz3C__"